/**
 * Map language codes to ISO 3166-1 alpha-2 country codes for regional
 * indicator flag emojis. Language codes that are not valid country codes
 * (or that would produce the wrong flag) must be listed here.
 */
const languageToCountryMap: Record<string, string> = {
  af: 'za',
  ar: 'sa',
  cs: 'cz',
  da: 'dk',
  el: 'gr',
  en: 'gb',
  et: 'ee',
  he: 'il',
  ja: 'jp',
  ka: 'ge',
  ko: 'kr',
  nb: 'no',
  sl: 'si',
  sr: 'rs',
  sv: 'se',
  uk: 'ua',
  vi: 'vn',
  zh: 'cn',
};

/** Regional indicator flag emoji for a HirePort language code (e.g. en → 🇬🇧). */
export function getLanguageFlagEmoji(code: string): string {
  const countryCode = languageToCountryMap[code] || code;
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((x) => 0x1f1a5 + x.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}
